module.exports = __webpack_public_path__ + "img/xmxx.2c604452.png";